import React from 'react';

import LoadingAnimation from '../../../../../assets/animations/loading.gif';
import CustomModal from '../CustomModal/CustomModal';

import './LoadingModal.scss';

interface ILoadingModal {
  showModal: boolean;
  description?: string;
}

const LoadingModal = ({ showModal, description }: ILoadingModal) => {
  return (
    <CustomModal open={showModal}>
      <div className="loading-modal" data-experience="new">
        <div className="loading-modal-container">
          <img src={LoadingAnimation} className="image" alt="btf-loading-animation" />
          {description && <div className="mt-8">{description}</div>}
        </div>
      </div>
    </CustomModal>
  );
};

export default LoadingModal;
